/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import ImageBlock from "theme/libs/wordpress/content/cmsBlocks/ImageBlock";
import ModuleAspectWrapperLarge from "theme/components/wrappers/ModuleAspectWrapperLarge";

const ImageModule = ({ content, isFirstModule }) => {
    const { is_image_ratio_inactivated: isImageRatioInactivated = false } = content;

    return isImageRatioInactivated ? (
        <ImageBlock isFullscreen isFirstModule={isFirstModule} content={content} />
    ) : (
        <ModuleAspectWrapperLarge>
            <ImageBlock isFullscreen isFirstModule={isFirstModule} content={content} />
        </ModuleAspectWrapperLarge>
    );
};

ImageModule.propTypes = {
    content: PropTypes.object,
    isFirstModule: PropTypes.bool,
};

ImageModule.defaultProps = {
    content: {},
    isFirstModule: false,
};

export default ImageModule;
